import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { TextWithStyle as ITextWithStyle } from '../types';

interface Props {
  texts: ITextWithStyle[];
  fontCls: string;
}

const TextWithStyle = (props: Props) => {
  const { texts = [], fontCls = '' } = props;

  if (texts && !(texts?.length > 0)) {
    return <></>;
  }

  return (
    <div className={ivclass(fontCls)}>
      {texts.map((text, i) => (
        <span key={i} className={ivclass(text.colorCls)}>
          {text.text}
        </span>
      ))}
    </div>
  );
};

export default TextWithStyle;
